module.exports = "<p>\r\n  login-by-token redirecting...\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/login-by-token/login-by-token.component.html
// module id = ./src/app/login-by-token/login-by-token.component.html
// module chunks = main